import style from "./mainArticle1.module.scss";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useMainScrolling, usePage, useUserAgent } from "../../../hooks/hooks";
import audience from "../../../assets/images/main/article1/press/audience.png";
import audienceMobile from "../../../assets/images/main/article1/press/audience_mobile.png";
import dcasExperience1 from "../../../assets/images/sub/experience/dcas_experience_image_1.png";
import dcasExperience2 from "../../../assets/images/sub/experience/dcas_experience_image_2.png";
import { StrongTextStyle } from "../../common/StyledCommonComponents";
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver";
import { Trans, useTranslation } from "react-i18next";

interface VideoData {
  url: string;
  urlNotKO?: string;
  thumbnail: string;
  textElement: JSX.Element;
}
export function Article1Press() {
  const { t } = useTranslation("aboutDcas");
  const { isDesktop } = useUserAgent();
  const { isWithAppPage } = usePage();
  const mainVideoWrapperRef = useRef<HTMLDivElement>(null);
  const mainVideoRef = useRef<HTMLVideoElement>(null);
  const audienceRef = useRef<HTMLDivElement>(null);
  const [selectedVideoIdx, ] = useState(0);
  const [showMainVideo, setShowMainVideo] = useState(false);
  const [, setShowMaxAndPiece] = useState(false);
  const [, setIsFirstLoadOnMobile] = useState(false);
  const [, setIsThumbnailLoaded] = useState(false);
  const { article1Element } = useMainScrolling();

  useEffect(() => {
    if (isWithAppPage) {
      setIsFirstLoadOnMobile(true);
      return;
    }

    if (!isDesktop) {
      if (showMainVideo) {
        setIsFirstLoadOnMobile(false);
      } else {
        setIsFirstLoadOnMobile(true);
      }
    }
  }, [isWithAppPage, isDesktop, showMainVideo]);

  const OpeningAngleBracket = useCallback(() => <>&lt;</>, []);
  const ClosingAngleBracket = useCallback(() => <>&gt;</>, []);

  // eslint-disable-next-line
  const videos: VideoData[] = useMemo(
    () => [
      {
        url: `${process.env.PUBLIC_URL}assets/video/maekyung_tv_magazine_today.mp4`,
        urlNotKO: `${process.env.PUBLIC_URL}assets/video/maekyung_tv_magazine_today_not_ko.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}assets/video/maekyung_tv_magazine_today_thumbnail.png`,
        textElement: (
          <Trans
            t={t}
            i18nKey={"press.video2.description"}
            components={[<StrongTextStyle />, <OpeningAngleBracket />, <ClosingAngleBracket />]}
          />
        ),
      },
      {
        url: `${process.env.PUBLIC_URL}assets/video/SBS_Biz_trend_special.mp4`,
        urlNotKO: `${process.env.PUBLIC_URL}assets/video/SBS_Biz_trend_special_not_ko.mp4`,
        thumbnail: `${process.env.PUBLIC_URL}assets/video/SBS_Biz_trend_special_thumbnail.png`,
        textElement: (
          <Trans
            t={t}
            i18nKey={"press.video1.description"}
            components={[<StrongTextStyle />, <OpeningAngleBracket />, <ClosingAngleBracket />]}
          />
        ),
      },
    ],
    [t, ClosingAngleBracket, OpeningAngleBracket]
  );

  useIntersectionObserver({
    targetRef: mainVideoWrapperRef,
    callbackOnIntersecting: () => {
      setShowMainVideo(true);
      setIsThumbnailLoaded(true);
    },
    callbackOnNotIntersecting: () => setShowMainVideo(false),
  });

  useIntersectionObserver({
    targetRef: audienceRef,
    callbackOnIntersecting: () => setShowMaxAndPiece(true),
    callbackOnNotIntersecting: () => setShowMaxAndPiece(false),
  });

  useEffect(() => {
    if (showMainVideo && mainVideoRef.current) {
      mainVideoRef.current.play().then();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMainVideo, mainVideoRef.current, selectedVideoIdx]);

  // const selectedVideo = useMemo(() => videos[selectedVideoIdx], [videos, selectedVideoIdx]);
  // const selectedVideoUrl = useMemo(() => {
  //   if (isNotKorean && selectedVideo.urlNotKO) return selectedVideo.urlNotKO;
  //   else return selectedVideo.url;
  // }, [isNotKorean, selectedVideo]);

  return (
    <section className={style.pressSection} ref={article1Element}>
      {/* <div className={`${style.maxAndPiece} ${showMaxAndPiece ? style.show : style.hide}`}>
        <img src={maxAndPiece} alt={"max and piece character"} />
      </div> */}
      <div className={style.audienceBgItem} ref={audienceRef}>
        <img src={isDesktop ? audience : audienceMobile} alt={"audience"} />
      </div>
      <div className={style.titleArea}>
        <p className={style.titleText}>{t("title")}</p>
        <p className={style.descriptionText}>
          {t("desc.line1")} <br />
          {t("desc.line2")} <br />
          {t("desc.line3")}
        </p>
        <div className={style.imageContainer}>
          <img className={style.firstImg} src={dcasExperience1} alt={"d-cas체험 이미지1"} />
          <img className={style.secondImg} src={dcasExperience2} alt={"d-cas체험 이미지2"} />
        </div>
      </div>

      {/* <div className={style.pressContent}>
        <div className={style.texts}>
          <h2 className={style.pressTitle}>
            <Trans t={t} i18nKey={"press.video1.title"} components={[<StrongTextStyle />]} />
          </h2>
          <p
            key={selectedVideoIdx}
            className={`${style.pressDescription} ${
              isFirstLoadOnMobile || (showMainVideo && isVideoStarted) ? style.show : ""
            }`}
          >
            {videos[selectedVideoIdx].textElement}
          </p>
        </div> 
      </div> */}
    </section>
  );
}
